import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export default function RatingComponent(props){

    return (
        <>
            {[...Array(props.rating)].map((_, i) => (
                <FontAwesomeIcon icon={faStar} key={i} className={'icon'}/>
            ))}
        </>
    )
}
